module.exports = __webpack_public_path__ + "static/media/customer-type.1ecb7b3e.png";